

export const environment = {
    production: false,
    cognito: {
      userPoolId: 'ap-southeast-2_8qZlPRYi1',
      userPoolWebClientId: '4nfs3d8gg5il6e1epcs8oqdo00',
    },
    wsEndpoint: 'wss://z334kb78wl.execute-api.ap-southeast-2.amazonaws.com/prod?Auth=',
    apiEndpoint: 'https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod',
  };
  
  
  
